module.exports = __webpack_public_path__ + "bg.754101f175a9ec76c3b2.jpg";


//////////////////
// WEBPACK FOOTER
// E:/Git_new/IVMS_PRO/web/src/assets/images/bg.jpg
// module id = ../../../../../src/assets/images/bg.jpg
// module chunks = styles